import { useQueryStates } from 'nuqs';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '@/components/session/useSession';
import { PATHS } from '@/routes/paths';
import { SEARCH_PARAMS } from '@/routes/search-params';
import { DataCollectionBuildingsTabEnum } from '@/routes/search_params/searchParamsEnums';

/**
 * Router-level guard that redirects the old `?tab=ECONOMIC_UNITS` URL
 * on the buildings page to the standalone economic units page.
 *
 * If the economic units feature is not toggled, it falls back to the buildings tab.
 */
export function RedirectEconomicUnitsTab({ children }: { children: ReactNode }) {
  const [queryParams] = useQueryStates(SEARCH_PARAMS.dataCollection.buildings);
  const {
    org: { isEconomicUnitsToggled },
  } = useSession();

  if (queryParams.tab === DataCollectionBuildingsTabEnum.ECONOMIC_UNITS) {
    if (isEconomicUnitsToggled) {
      return <Navigate to={PATHS.dataCollection.economicUnits()} replace />;
    }
    return (
      <Navigate to={PATHS.dataCollection.buildings(null, { tab: DataCollectionBuildingsTabEnum.BUILDINGS })} replace />
    );
  }

  return <>{children}</>;
}
